<template>
    <ion-page>
        <standard-header/>
        <ion-content :fullscreen="true">
            <ion-card>
                <ion-item>
                    <ion-label>
                        <h3>Scanning Demo</h3>
                        <p>Updated: Jan 2021</p>
                    </ion-label>
                </ion-item>
                <ion-card-header>
                    Card Header
                </ion-card-header>
                <ion-card-content>
                    <p>1. Place the product in front of the device</p>
                    <p>2. Tap Scan</p>
                </ion-card-content>
                <ion-footer>
                    <ion-button @click="scan" expand="block">Scan Product</ion-button>
                </ion-footer>
            </ion-card>
        </ion-content>
    </ion-page>
</template>

<script>
import {IonPage, IonContent, alertController} from '@ionic/vue';
import {IonCard, IonCardHeader, IonCardContent, IonLabel, IonItem, IonFooter, IonButton} from '@ionic/vue';
import {settings, menu} from 'ionicons/icons';
import StandardHeader from '../../components/StandardHeader.vue';

export default {
    name: 'Scan',
    inject: ['$http', '$scanner'],
    components: {
        StandardHeader, IonContent, IonPage,
        IonCard, IonCardHeader, IonCardContent, IonLabel, IonItem, IonFooter, IonButton,
    },
    methods: {
        scan() {
            this.$scanner.scan().then(response => {
                alertController.create({
                    header: 'Scan Test',
                    message: response.barcode,
                    buttons: ['Ok']
                }).then(alert => alert.present());
            });
        }
    },
    setup() {
        return {
            settings,
            menu
        }
    }
}
</script>
